export default "__VITE_ASSET__BHNsUjNz__"